module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAUCAYAAAB4d5a9AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADpSURBVHgB7ZXdEYIwEIQ3MxZACelAS9AOsAM6sARbsANLQCsgVqBWAB1IB3FvzAOGEPnzxfGbWQZykGOSvQsQwVq7ox5USe0xEsWPdUdsSZ28sS11wzBqSXLlTRIIJoHx2mkIpjPC5IltozE3nDSlCiqn1vgzFWfz3Eljbjhp5hmjFMP478Us3IeQzSvv2SiXeWySjGp2AqmhDd5raWhdteFPHtxSSftJ8dOoWNDtV4bXuhqlVIU5Ec87S0bt2Qdx17EjJhP6G2nQtugnLgtezghbWAeS3DHiPIlGpVAby1XgW0iLp1aYwBPcnLrZwzcYVAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ui/editing-icon.png
// module id = FNy8
// module chunks = 1